import { editableTranslations, images } from '$lib/stores';
import { dictionary, locale, waitLocale } from 'svelte-i18n';
import type { LayoutLoad } from './$types';
import { error } from '@sveltejs/kit';

export const load: LayoutLoad = async ({ data }) => {
  if (!data.editableTranslations || !data.dictionary || !data.images) {
    console.error('load +layout.ts error');
    throw error(500, 'Omlouváme se, ale došlo k chybě při načítání stránky. (Error: P2)');
  }
  editableTranslations.set(data.editableTranslations);
  dictionary.set(data.dictionary);
  locale.set('cs');
  images.set(Object.fromEntries(data.images));

  await waitLocale();
};
